window.initMenuDropdowns = function() {
  let currentlyOpenMenu = null;

  /**************************************************************
   * 1) Remove any previous doc listener to avoid duplicates
   **************************************************************/
  document.removeEventListener("click", docClickHandler);
  document.addEventListener("click", docClickHandler);

  // The single doc-level handler. We do a tiny setTimeout so the
  // trigger’s own click finishes first (including stopImmediatePropagation).
  function docClickHandler(e) {
    setTimeout(() => {
      if (currentlyOpenMenu && !currentlyOpenMenu.contains(e.target)) {
        closeMenu(currentlyOpenMenu);
        currentlyOpenMenu = null;
      }
    }, 0);
  }

  /**************************************************************
   * 2) For each .menu-container, attach local events
   **************************************************************/
  const menuContainers = document.querySelectorAll(".menu-container");

  menuContainers.forEach((container) => {
    const menuTrigger     = container.querySelector(".menu-trigger");
    const menuContent     = container.querySelector(".menu-content");
    const menuMain        = container.querySelector(".menu-main");
    const menuMechanical  = container.querySelector(".menu-mechanical");
    const mechanicalText  = container.querySelector(".mechanical-text");
    const backButton      = container.querySelector(".back-button");

    // Items
    const viewProductItem = container.querySelector(".menu-item-view");
    const mechanicalItem  = container.querySelector(".menu-item-mechanical");
    const toleranceItem   = container.querySelector(".menu-item-tolerance");

    // Data
    const variantUrl  = container.dataset.variantUrl  || "#";
    const mechanical  = container.dataset.mechanical  || "No mechanical properties.";
    const productId   = container.dataset.productId;

    // Safety check
    if (!menuTrigger) return;

    /**************************************************************
     * A) Trigger click => open or close this menu
     **************************************************************/
    menuTrigger.addEventListener("click", (e) => {
      // Stop the event from reaching docClickHandler in this same tick
      e.stopPropagation();
      e.stopImmediatePropagation(); // <<— more robust than stopPropagation()
      e.preventDefault();

      // If another container is open, close it
      if (currentlyOpenMenu && currentlyOpenMenu !== container) {
        closeMenu(currentlyOpenMenu);
        currentlyOpenMenu = null;
      }

      // Toggle
      const isAlreadyOpen = (menuContent && menuContent.style.display === "block");
      if (isAlreadyOpen) {
        closeMenu(container);
        currentlyOpenMenu = null;
      } else {
        openMenu(container);
        currentlyOpenMenu = container;
      }
    });

    /**************************************************************
     * B) “View Product”
     **************************************************************/
    if (viewProductItem) {
      viewProductItem.addEventListener("click", (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.href = variantUrl;
      });
    }

    /**************************************************************
     * C) “Mechanical Properties” => show sub-view
     **************************************************************/
if (mechanicalItem) {
  mechanicalItem.addEventListener("click", (e) => {
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (menuMain)       menuMain.style.display       = "none";
    if (menuMechanical) menuMechanical.style.display = "block";

    if (mechanicalText) {
      mechanicalText.innerHTML = ""; // Clear previous content

      // Split mechanical properties into separate lines
      const lines = mechanical.split("\n");

      lines.forEach(line => {
        const div = document.createElement("div");

        // Check if the line contains a colon (":") to determine if there's a label
        const parts = line.split(":");
        if (parts.length > 1) {
          const strong = document.createElement("strong");
          strong.textContent = parts[0] + ":"; // Add the label with colon

          const textNode = document.createTextNode(" " + parts.slice(1).join(":")); // Join remaining text

          div.appendChild(strong);
          div.appendChild(textNode);
        } else {
          div.textContent = line; // No colon, just add the text
        }

        div.style.marginBottom = "8px"; // Add spacing between lines
        mechanicalText.appendChild(div);
      });
    }
  });
}



    /**************************************************************
     * D) “Back” => return to main menu
     **************************************************************/
    if (backButton) {
      backButton.addEventListener("click", (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (menuMechanical) menuMechanical.style.display = "none";
        if (menuMain)       menuMain.style.display       = "block";
      });
    }

    /**************************************************************
     * E) “Tolerance Chart” => close + open modal
     **************************************************************/
    if (toleranceItem) {
      toleranceItem.addEventListener("click", (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();

        closeMenu(container);
        if (currentlyOpenMenu === container) {
          currentlyOpenMenu = null;
        }
        const modal = document.getElementById(`tolerance-modal-${productId}`);
        if (modal) {
          modal.style.display = "flex";
        }
      });
    }
  });

  /**************************************************************
   * 3) Helper Functions
   **************************************************************/
  function openMenu(container) {
    console.log("openMenu called");
    const menuMain       = container.querySelector(".menu-main");
    const menuMechanical = container.querySelector(".menu-mechanical");
    const menuContent    = container.querySelector(".menu-content");

    // Reset to main sub-view
    if (menuMain)       menuMain.style.display       = "block";
    if (menuMechanical) menuMechanical.style.display = "none";

    // Show the container
    if (menuContent)    menuContent.style.display    = "block";
  }

  function closeMenu(container) {
    console.log("closeMenu called");
    const menuContent = container.querySelector(".menu-content");
    if (menuContent) menuContent.style.display = "none";
  }

  // Debug logs
  console.log("initMenuDropdowns() CALLED");
  console.log("Found X menu containers:", menuContainers.length);
};
